import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNominationColumnDisplay({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M3 1.75a.75.75 0 01.743.648l.007.102v5H4a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-.25v3a.75.75 0 01-1.493.102L2.25 13.5v-3H2a.5.5 0 01-.5-.5V8a.5.5 0 01.5-.5h.25v-5A.75.75 0 013 1.75zm5 0a.75.75 0 01.743.648l.007.102H9a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-.25v8a.75.75 0 01-1.493.102L7.25 13.5v-8H7a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h.25A.75.75 0 018 1.75zm5 0a.75.75 0 01.743.648l.007.102v8H14a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-.25a.75.75 0 01-1.493.102l-.007-.102H12a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5h.25v-8a.75.75 0 01.75-.75z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgNominationColumnDisplay.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNominationColumnDisplay.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgNominationColumnDisplay svgRef={ref} {...props} />
));
export default ForwardRef;
